import {useTranslation} from '#imports';
import {WorkedUnit} from '@api';

export function useFormatTotalText(time: number, unit: WorkedUnit): string {
    const {t} = useTranslation();

    const unitValue = unit === WorkedUnit.Day ? t('projectclient.activitytracker.days') : t('projectclient.activitytracker.hours');

    return `${time} ${unitValue}`;
}
